import React from "react";

const INVERTED = new Set([
  "cancellation_rate_pct", "no_show_rate_pct", "rescheduled_pct",
  "overtime_hours", "lost_revenue_no_shows", "lost_revenue_cancellations",
  "unfilled_slots_pct",
]);

export function computeDelta(current, previous, invertColor = false) {
  if (previous == null || previous === 0) return { pct: null, direction: "neutral", color: "neutral" };
  const diff = current - previous;
  const pct = Math.abs((diff / previous) * 100).toFixed(1);
  const direction = diff > 0 ? "up" : diff < 0 ? "down" : "neutral";
  let color = "neutral";
  if (diff !== 0) {
    const isGood = invertColor ? diff < 0 : diff > 0;
    color = isGood ? "positive" : "negative";
  }
  return { pct, direction, color };
}

const colorMap = {
  positive: { bg: "#ECFDF5", text: "#059669" },
  negative: { bg: "#FEF2F2", text: "#DC2626" },
  neutral:  { bg: "#F3F4F6", text: "#6B7280" },
};

const DeltaBadge = ({ current, previous, metricKey, invertColor }) => {
  const invert = invertColor ?? INVERTED.has(metricKey);
  const { pct, direction, color } = computeDelta(current, previous, invert);
  if (pct === null) return null;

  const { bg, text } = colorMap[color];
  const arrow = direction === "up" ? "↑" : direction === "down" ? "↓" : "–";

  return (
    <span style={{
      display: "inline-flex", alignItems: "center", gap: "2px",
      padding: "2px 7px", borderRadius: "9999px",
      fontSize: "11px", fontWeight: "600",
      background: bg, color: text,
    }}>
      {arrow} {pct}%
    </span>
  );
};

export default DeltaBadge;
